import React from "react";
import FotoKita1 from '../assets/images/09.jpg'
import FotoKita2 from '../assets/images/39.jpg'
import FotoKita3 from '../assets/images/53.jpg'
import FotoKita4 from '../assets/images/73.jpg'
import FotoKita5 from '../assets/images/77.jpg'

const AboutCard = ()=>{
    return (

      
        <>
        
        <p>
          <p></p>
        </p>
        
        
<div class="row row-cols-9 row-cols-md-1 g-3">



  {/* <div class="row text-center">
    <div class="col-xl-4 col-sm-6 mb-5">
      <div class="bg-white rounded shadow-sm py-6 px-6"><  img src="https://i.ibb.co/6rhg31W/73.jpg"
 alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
      <h5 class="mb-0">Farhan Maulana</h5><span class="small text-uppercase text-muted">UI/UX Designer</span>
      <ul class="social mb-0 list-inline mt-3">
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-facebook-f"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-twitter"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-instagram"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-linkedin"></i></a></li>
          </ul>
      </div>
    </div>
  </div> */}


<div className="wrap">
      </div>

  <div class="container py-5 md-5">
    <div class="row mb-5">
      <div class="col-lg-6">
        <h1 class="display-1 font-weight-light">Vitour team</h1>
        <p class="font-italic text-muted">Meet our best team!</p>
      </div>
    </div>

    <div class="row text-center">
      <div class="col-xl-6 col-sm-6 mb-5 row-center">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://telegra.ph/file/29e69b9fc9912d1d9c2dd.jpg" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
          <h5 class="mb-0">Muhammad Alwan Fauzi</h5>
          <h5 class="mb-0">140810190077</h5><span class="small text-uppercase text-muted">Project Manager</span>
          <ul class="social mb-0 list-inline mt-3">
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-facebook-f"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-twitter"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-instagram"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>

      <div class="col-xl-6 col-sm-6 mb-5">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://telegra.ph/file/43e6249b05ff682a42350.jpg" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
        <h5 class="mb-0">Aidil Fitra</h5>
        <h5 class="mb-0">140810190053</h5><span class="small text-uppercase text-muted">Scrum Master</span>
          <ul class="social mb-0 list-inline mt-3">
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-facebook-f"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-twitter"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-instagram"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6 mb-5">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://telegra.ph/file/2a8705447920571c79846.jpg" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
        <h5 class="mb-0">Muhammad Raihan Fatoni</h5>
        <h5 class="mb-0">140810190039</h5><span class="small text-uppercase text-muted">Back End</span>
          <ul class="social mb-0 list-inline mt-3">
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-facebook-f"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-twitter"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-instagram"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6 mb-5">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://telegra.ph/file/422c75a705c3befa15c4a.jpg" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
        <h5 class="mb-0">Farhan Gunadi</h5>
        <h5 class="mb-0">140810190009</h5><span class="small text-uppercase text-muted">Front End</span>
          <ul class="social mb-0 list-inline mt-3">
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-facebook-f"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-twitter"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-instagram"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>

      <div class="col-xl-4 col-sm-6 mb-5">
        <div class="bg-white rounded shadow-sm py-5 px-5"><img src="https://telegra.ph/file/fb3735e042d383beb8648.jpg" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
        <h5 class="mb-0">Farhan Maulana</h5>
        <h5 class="mb-0">140810190073</h5><span class="small text-uppercase text-muted">UI/UX Designer</span>
          <ul class="social mb-0 list-inline mt-3">
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-facebook-f"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-twitter"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-instagram"></i></a></li>
            <li class="list-inline-item"><a href="#" class="social-link"><i class="fa fa-linkedin"></i></a></li>
          </ul>
        </div>
      </div>

      

    </div>
  </div>






 {/* <div class="row text-center">
      <div class="col-xl-3 col-sm-6 mb-4">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://telegra.ph/file/29e69b9fc9912d1d9c2dd.jpg" alt="" width="150" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
          <h5 class="mb-0">Muhammad Alwan Fauzi</h5><span class="small text-uppercase text-muted">Project Manager</span>
        </div>
      </div>
      </div>  

      <div class="row text-center">
      <div class="col-xl-3 col-sm-6 mb-5">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://bootstrapious.com/i/snippets/sn-about/avatar-4.png" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
          <h5 class="mb-0">Manuella Nevoresky</h5><span class="small text-uppercase text-muted">CEO - Founder</span>
        </div>
      </div>
      </div>  

      <div class="row text-center">
      <div class="col-xl-3 col-sm-6 mb-5">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://bootstrapious.com/i/snippets/sn-about/avatar-4.png" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
          <h5 class="mb-0">Manuella Nevoresky</h5><span class="small text-uppercase text-muted">CEO - Founder</span>
        </div>
      </div>
      </div>  

      <div class="row text-center">
      <div class="col-xl-3 col-sm-6 mb-5">
        <div class="bg-white rounded shadow-sm py-5 px-4"><img src="https://bootstrapious.com/i/snippets/sn-about/avatar-4.png" alt="" width="100" class="img-fluid rounded-circle mb-3 img-thumbnail shadow-sm"></img>
          <h5 class="mb-0">Manuella Nevoresky</h5><span class="small text-uppercase text-muted">CEO - Founder</span>
        </div>
      </div>
      </div>   */}
</div>

{/* <div class="col">
    <div class="card">
    <img src={FotoKita5} class=" mx-auto card-img-fluid" alt="..." width={250} height={300} />
      <div class="card-body">
        <h5 class="card-title">Aidil Fitra</h5>
        <p class="card-text">Scrum Master</p>
      </div>
    </div>
  </div>
        <div class="card-group">
        <div class="card">
        <img src={FotoKita1} class="mx-auto card-img-fluid" alt="..." width={250} height={300}/>
          <div class="card-body">
            <h5 class="card-title">Farhan Gunadi</h5>
            <p class="card-text">Front End</p>
          </div>
        </div>
        <div class="card">
        <img src={FotoKita2} class="mx-auto card-img-fluid" alt="..." width={250} height={300}/>
          <div class="card-body">
            <h5 class="card-title">Raihan Fatoni</h5>
            <p class="card-text">Back End</p>
          </div>
        </div>
        <div class="card">
        <img src={FotoKita3} class="mx-auto card-img-fluid" alt="..." width={250} height={300}/>
          <div class="card-body">
            <h5 class="card-title">Farhan Maulana</h5>
            <p class="card-text">UI/UX Designer & Front End</p>
          </div>
        </div>
      </div> */}

      
      

      
      </>
    )
}

export default AboutCard;